import { Injectable } from '@angular/core';
import { StorageDataAccess } from './abstraction/storage.data-access';

@Injectable({providedIn: 'root'})
export class LocalStorageDataAccess extends StorageDataAccess {
  constructor() {
    super(localStorage);
  }
}
